import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { BUSINESS } from "@/lib/business";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#080808] border-t border-white/5 pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-10 border-b border-white/5">
          <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src="/mp-logo.svg"
              alt="MP Carrosserie"
              className="h-14 md:h-16 w-auto"
            />
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono">
                {t.footer.tagline}
              </div>
            </div>
          </div>
            <p className="mt-6 text-zinc-400 leading-relaxed max-w-md">
              Schweizer Carrosserie- und Lackierhandwerk in Wolfwil. Inhaber {BUSINESS.owner}.
            </p>
            <a
              href="/certificates/CFS-Zertifikat-MP-Carrosserie-2026.pdf"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-iso-badge"
              className="mt-5 inline-flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-400 hover:text-white border border-white/10 hover:border-[#e52620]/50 rounded-full px-3 py-1.5 transition-colors duration-300"
              title="CertifiedFirst Switzerland · ISO 9001 / 14001 / 45001"
            >
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#e52620]" />
              ISO 9001 · 14001 · 45001
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono font-bold mb-4">
              {t.contact.info.address_label}
            </div>
            <ul className="space-y-3 text-zinc-300 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-zinc-500" />
                <span>
                  {BUSINESS.address}, {BUSINESS.city}
                </span>
              </li>
              <li>
                <a href={`tel:${BUSINESS.phoneOwner.replace(/\s/g, "")}`} className="flex items-start gap-2 hover:text-white">
                  <Phone className="w-4 h-4 mt-0.5 text-zinc-500" />
                  {BUSINESS.phoneOwner}
                </a>
              </li>
              <li>
                <a href={`mailto:${BUSINESS.email}`} className="flex items-start gap-2 hover:text-white">
                  <Mail className="w-4 h-4 mt-0.5 text-zinc-500" />
                  {BUSINESS.email}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono font-bold mb-4">
              Navigation
            </div>
            <ul className="space-y-2 text-zinc-300 text-sm">
              <li><a href="#services" className="hover:text-white">{t.nav.services}</a></li>
              <li><a href="#accident" className="hover:text-white">{t.nav.accident}</a></li>
              <li><a href="#gallery" className="hover:text-white">{t.nav.gallery}</a></li>
              <li><a href="#about" className="hover:text-white">{t.nav.about}</a></li>
              <li><a href="#contact" className="hover:text-white">{t.nav.contact}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono font-bold mb-4">
              Social
            </div>
            <a
              href={BUSINESS.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center gap-2 text-zinc-300 hover:text-white text-sm"
            >
              <Instagram className="w-4 h-4" />
              @{BUSINESS.instagramHandle}
            </a>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-zinc-500 font-mono">
          <div>
            © {year} MP Carrosserie · UID {BUSINESS.uid} · {t.footer.rights}
          </div>
          <Link
            to="/impressum"
            data-testid="footer-impressum-link"
            className="hover:text-white uppercase tracking-[0.2em]"
          >
            {t.footer.impressum}
          </Link>
        </div>
      </div>
    </footer>
  );
}
